import { AgGridReact } from '@ag-grid-community/react';
import { Grid } from '@mui/material';
import { useAgGrid } from '@tassat/ag-grid';
import React from 'react';

import { AG_GRID_SMALL_HEADER_HEIGHT } from 'Lib/constant';
import DateCellRender from 'SharedComponents/cellRenderComponent/datecellrender';

import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-material.css';
import { getColumnDef } from './gridOptions';
import { ExecutionsTableProps } from './types';

export const ExecutionsTable = (props: ExecutionsTableProps) => {
    const { executionList, asset, transaction } = props;
    const [ , onGridReady ] = useAgGrid();
    const columnDefs = getColumnDef(transaction);

    return (
        <Grid xs={9}>
            <div
                className='ag-theme-material'
                id='executionsGrid'
                style={{
                    height: '400px',
                    width: '100%'
                }}
            >
                <AgGridReact
                    animateRows={false}
                    columnDefs={columnDefs}
                    columnMenu='legacy'
                    components={{ dateCellRender: DateCellRender }}
                    context={{ asset: { ...asset }}}
                    defaultColDef={{
                        resizable: true,
                        filter: true,
                        sortable: true
                    }}
                    enableCellTextSelection={true}
                    getRowId={({ data }) => data.ExecutionId}
                    headerHeight={AG_GRID_SMALL_HEADER_HEIGHT}
                    onGridReady={onGridReady}
                    rowData={executionList}
                    suppressCellFocus={true}
                    suppressContextMenu={true}
                />
            </div>
        </Grid>
    );
};